var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1244 3.82609C13.0547 3.74053 12.9828 3.65667 12.9089 3.5746C11.6632 2.19362 9.89713 1.3913 8 1.3913C4.34962 1.3913 1.3913 4.34962 1.3913 8C1.3913 11.6504 4.34962 14.6087 8 14.6087C11.6504 14.6087 14.6087 11.6504 14.6087 8H16C16 12.4188 12.4188 16 8 16C3.58122 16 0 12.4188 0 8C0 3.58122 3.58122 0 8 0C10.2951 0 12.4352 0.972213 13.9423 2.64305C13.9793 2.6842 14.016 2.72573 14.0522 2.76761V0.347826H15.4435V5.21739H10.5739V3.82609H13.1244Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepromptIcon);
export default __webpack_public_path__ + "static/media/reprompt-icon.fcac6b8980acd602ef6d3e0eee973cfd.svg";
export { ForwardRef as ReactComponent };